import React from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { LogIn } from "lucide-react";

const links = [
  { to: "/cursos", label: "Cursos" },
  { to: "/profissionais", label: "Profissionais" },
  { to: "/sobre", label: "Sobre" },
  { to: "/validar", label: "Validar certificado" },
];

export const PublicHeader = () => {
  const navigate = useNavigate();
  return (
    <header className="h-16 sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200 px-4 sm:px-6 flex items-center justify-between">
      <button onClick={() => navigate("/cursos")}><Brand size="md" /></button>
      <nav className="hidden md:flex items-center gap-1">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            className={({ isActive }) =>
              `px-3 py-2 rounded-lg text-sm font-medium transition-colors ${isActive ? "text-[#232D4F] bg-slate-100" : "text-slate-500 hover:text-slate-800"}`
            }
          >
            {l.label}
          </NavLink>
        ))}
      </nav>
      <Button data-testid="public-login-button" onClick={() => navigate("/login")} className="text-white" style={{ background: "#232D4F" }}>
        <LogIn className="h-4 w-4 mr-1.5" /> Entrar
      </Button>
    </header>
  );
};
